export interface Input {
  content: Marko.Body;
}

<h2 class="text1 font-semibold">
  <${input.content}/>
</h2>
